export default "__VITE_ASSET__Bji5k$kL__"